import { style } from '@angular/animations';
import { Directive, HostListener, Input, OnChanges, SimpleChanges } from "@angular/core";
import { validation_options_interface } from "../interfaces/validation.interface";







@Directive({
   selector: '[validate]'
})
export class Validation_Directive
{

   @Input() validate!: validation_options_interface;
   @Input() mutate: any;


   @HostListener('input') input() {
    console.log("fieed")

      this.validate_form_control();

   }

   @HostListener('focusout') focusout() {
console.log("fieed")
      this.validate_form_control();

   }

   @HostListener('touchstart') onTouchStart() {
    console.log("touchstart")
   }

   @HostListener('touchend') ontouchend() {
    console.log("touchstart")

   }

   validate_form_control()
   {


      let fg = this.validate.form_group;
      let fc = this.validate.control_name;

      let validation = fg.controls[fc].invalid && (fg.controls[fc].dirty || fg.controls[fc].touched);
      ;
console.log(this.mutate)


      if ( validation )
      {
         this.mutate.style.backgroundColor = 'red';
         this.mutate.style['text-align'] = 'start'
         this.mutate.style.color = 'red'

         this.mutate.innerText = this.validate.error;

      }
      else
      {
         this.mutate.style.backgroundColor = '#7e859b';
         this.mutate.innerText = '';

      }

   }



}
